import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminPermissionsNew } from '../hooks/useAdminPermissionsNew';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, CircularProgress } from '@mui/material';
import { HiShieldExclamation } from 'react-icons/hi';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ 
  children
}) => {
  const adminPermissions = useAdminPermissionsNew();
  const location = useLocation();
  const { isAuthenticated, loading, isSessionReady } = useAuth();



  // First: Wait for basic auth to be ready
  if (loading || !isSessionReady) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        gap: 2
      }}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Verificando autenticación...
        </Typography>
      </Box>
    );
  }

  // Second: Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Third: Check if user has admin permissions
  if (!adminPermissions.isAdmin) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh', 
        gap: 3,
        textAlign: 'center',
        p: 3
      }}>
        <HiShieldExclamation size={64} color="error" />
        <Typography variant="h4" component="h1" gutterBottom>
          Acceso Denegado
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500 }}>
          No tienes permisos de administrador para acceder a esta sección. 
          Contacta a un administrador si crees que esto es un error.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Permisos requeridos: ADMIN_ACCESS o SUPER_ADMIN
        </Typography>
      </Box>
    );
  }

  // User has admin permissions, render the admin content
  return <>{children}</>;
};

export default AdminProtectedRoute;
